import { render, staticRenderFns } from "./ExibirMembro.vue?vue&type=template&id=3bf6672e&scoped=true&"
import script from "./ExibirMembro.vue?vue&type=script&lang=js&"
export * from "./ExibirMembro.vue?vue&type=script&lang=js&"
import style0 from "./ExibirMembro.vue?vue&type=style&index=0&id=3bf6672e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf6672e",
  null
  
)

export default component.exports